import React from 'react'

interface Props {
  id: string
  onClick: (e: React.MouseEvent) => void
}

const CloseButton: React.FC<Props> = ({ id, onClick }) => {
  return (
    <button
      id={id}
      type="button"
      aria-label="close"
      className="text-gray-icons dark:text-gray-icons-dm"
      onClick={onClick}>
      <i className="text-xl nf-icon nf-close" />
    </button>
  )
}

export default CloseButton
